import { theme } from '@fiverr-private/theme';
import useMediaQueries from '../useMediaQueries';

type Breakpoint = keyof typeof theme.numericBreakpoints;

type Breakpoints = Record<Breakpoint, boolean> & { default: boolean };

const useBreakpoints = (): Breakpoints => useMediaQueries(theme.breakpoints);

export default useBreakpoints;
